import { Link } from 'react-router-dom'
import { ChevronRight, Shield } from 'lucide-react'
import { PageHeader } from '@/components/PageHeader'
import { Card } from '@/components/ui/Card'
import { adminSections } from '@/config/adminSections'
import { copy } from '@/lib/copy'
import { cn } from '@/components/ui/cn'

export function AdminHubPage() {
  return (
    <div data-testid="admin-hub">
      <PageHeader
        title={copy.admin.hubTitle}
        description={copy.admin.hubDescription}
      />

      <div className="grid gap-4 sm:grid-cols-2">
        {adminSections.map(({ to, title, description, icon: Icon, testId }) => (
          <Link key={to} to={to} data-testid={testId} className="group block">
            <Card
              className={cn(
                'h-full p-5 transition-colors',
                'hover:border-primary/40 hover:bg-primary/[0.03]',
              )}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex min-w-0 flex-1 gap-3">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="min-w-0">
                    <h2 className="font-semibold text-foreground group-hover:text-primary">
                      {title}
                    </h2>
                    <p className="mt-1 text-sm text-muted-foreground">{description}</p>
                  </div>
                </div>
                <ChevronRight className="mt-1 h-5 w-5 shrink-0 text-muted-foreground/50 transition-transform group-hover:translate-x-0.5 group-hover:text-primary" />
              </div>
            </Card>
          </Link>
        ))}
      </div>

      <p className="mt-6 flex items-center gap-2 text-xs text-muted-foreground">
        <Shield className="h-3.5 w-3.5" />
        {copy.admin.hubHint}
      </p>
    </div>
  )
}
